import React from 'react';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import {UserContextType} from 'components/triggers/UserContextType';

class UserIsUserConditionComponent extends React.Component {
  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores(nextProps) {
    const {context, contextType} = nextProps;
    const user = UserStore.getState().users.get(context.user_id);
    return {user, contextType};
  }

  componentDidMount() {
    const {context} = this.props;
    const user = UserStore.getState().users.get(context.user_id);
    if (!user) {
      UserActions.fetchUsers.defer([[context.user_id]]);
    }
  }

  displayUser(user) {
    return user ? user.getFullName() : '[SELECT USER]';
  }

  render() {
    const {user, contextType} = this.props;
    return (
      <div>
        {contextType === UserContextType.USER && (
          <span>
            <span onClick={this.props.onClick} className="condition-action">
              {this.displayUser(user)}
            </span>{' '}
            reviews a call
          </span>
        )}
        {contextType === UserContextType.CALLER && (
          <span>
            is placed or received by{' '}
            <span onClick={this.props.onClick} className="condition-action">
              {this.displayUser(user)}
            </span>
          </span>
        )}
        {contextType === UserContextType.CALL && (
          <span>
            the call is placed or received by{' '}
            <span onClick={this.props.onClick} className="condition-action">
              {this.displayUser(user)}
            </span>
          </span>
        )}
      </div>
    );
  }
}

export default connectToStores(UserIsUserConditionComponent);
